import { fmt, pct, type EquipmentResult } from "@h2lca/core";
import { css, STAGE_COLOR } from "@/lib/design";
import { RESULT_SHARE_MAX_SEGMENTS } from "@/lib/domain-rules";

/** 기여도 100% 누적 막대 , 상위 여섯 설비 + 기타. 조각 사이는 흰 틈, 이름은 아래 범례에 */
export function ShareBar({ byEquipment }: { byEquipment: EquipmentResult[] }) {
  const list = byEquipment.filter((e) => e.inBoundary && e.kgCO2eq > 0).sort((a, b) => b.kgCO2eq - a.kgCO2eq);
  if (list.length === 0) return <p className="text-footnote text-ink-subtle">배출량이 있는 설비가 없습니다.</p>;
  const head = list.slice(0, RESULT_SHARE_MAX_SEGMENTS);
  const tail = list.slice(RESULT_SHARE_MAX_SEGMENTS);
  const segs = head.map((e) => ({ id: e.equipmentId, name: e.name, share: e.share, kg: e.kgCO2eq, color: css(STAGE_COLOR[e.stage].fill) }));
  if (tail.length) {
    const kg = tail.reduce((a, e) => a + e.kgCO2eq, 0);
    segs.push({ id: "other", name: `기타 ${tail.length}개`, share: tail.reduce((a, e) => a + e.share, 0), kg, color: css("--color-tier-unknown-fill") });
  }
  return (
    <div>
      <div className="share-overview-track" role="img" aria-label="설비별 기여도">
        {segs.map((s) => (
          <span key={s.id} className="share-overview-segment" style={{ width: `${s.share * 100}%`, backgroundColor: s.color }} title={`${s.name} ${pct(s.share)}`} />
        ))}
      </div>
      <ul className="chart-legend">
        {segs.map((s) => (
          <li key={s.id} className="inline-flex items-center gap-label">
            <span className="chart-legend-dot" style={{ backgroundColor: s.color }} />
            <span className="text-ink">{s.name}</span>
            <span className="font-mono">
              {pct(s.share)}, {fmt(s.kg)} kg
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
